export const light = {
  "borderWidth": {
    "l": "3px",
    "m": "2px",
    "s": "1px"
  },
  "color": {
    "bg": {
      "background": "#fafdfd",
      "errorContainer": "#ffdad6",
      "infoContainer": "#d3e4ff",
      "inverseSurface": "#2e3132",
      "inverseSurfaceVariant": "#e1e3e3",
      "neutral": "#fff",
      "primaryContainer": "#71f7ed",
      "secondaryContainer": "#cce8e4",
      "successContainer": "#71f7ed",
      "surface": "#f7fafa",
      "surfaceOverlay": "#979eab",
      "surfaceVariant": "#dae5e2",
      "surface1": "#f2f5f6",
      "surface2": "#eff3f4",
      "surface3": "#ecf0f1",
      "surface4": "#ebeff1",
      "surface5": "#eaedef",
      "tertiaryContainer": "#eddcff",
      "warningContainer": "#ffe16f"
    },
    "border": {
      "outline": "#6f7977",
      "outlineVariant": "#bec9c7"
    },
    "brand": {
      "error": "#ba1a1a",
      "info": "#0060a8",
      "inversePrimary": "#4fdbd1",
      "onError": "#fff",
      "onInfo": "#fff",
      "onPrimary": "#fff",
      "onSecondary": "#fff",
      "onSuccess": "#fff",
      "onTertiary": "#fff",
      "onWarning": "#fff",
      "primary": "#006a64",
      "secondary": "#4a6360",
      "success": "#006a64",
      "tertiary": "#704da0",
      "warning": "#705d00"
    },
    "custom": {
      "bluePrimary": "#005faf",
      "corePrimary": "#006a64",
      "greenPrimary": "#006d44",
      "highchartsColor1": "#e91e63",
      "highchartsColor2": "#0288d1",
      "highchartsColor3": "#388e3c",
      "highchartsColor4": "#9c27b0",
      "highchartsColor5": "#5c6bc0",
      "highchartsColor6": "#b71c1c",
      "highchartsColor7": "#006064",
      "highchartsColor8": "#827717",
      "highchartsColor9": "#00897b",
      "highchartsColor10": "#e65100",
      "pinkPrimary": "#a82487",
      "purplePrimary": "#7542ba"
    },
    "fg": {
      "onBackground": "#0e1212",
      "onBlack": "#eff1f1",
      "onErrorContainer": "#410002",
      "onInfoContainer": "#001c38",
      "onInverseSurface": "#eff1f1",
      "onInverseSurfaceVariant": "#191c1d",
      "onNeutral": "#000",
      "onPrimaryContainer": "#00201e",
      "onSecondaryContainer": "#051f1e",
      "onSuccessContainer": "#00201e",
      "onSurface": "#191c1d",
      "onSurfaceVariant": "#3f4947",
      "onTertiaryContainer": "#290055",
      "onWarningContainer": "#221b00",
      "onWhite": "#191c1d"
    }
  },
  "content": {
    "body1": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1rem",
      "fontWeight": "400",
      "lineHeight": "1.5rem"
    },
    "body2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "400",
      "lineHeight": "1.25rem"
    },
    "body3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "400",
      "letterSpacing": "0.025rem",
      "lineHeight": "1rem"
    },
    "button": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "400",
      "lineHeight": "1.25rem"
    },
    "button2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "500",
      "lineHeight": "1rem"
    },
    "button3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.6875rem",
      "fontWeight": "500",
      "letterSpacing": "0.03125rem",
      "lineHeight": "1rem"
    },
    "caption": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "500",
      "lineHeight": "1.25rem"
    },
    "caption2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "500",
      "lineHeight": "1rem"
    },
    "caption3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.6875rem",
      "fontWeight": "500",
      "letterSpacing": "0.03125rem",
      "lineHeight": "1rem"
    },
    "overline": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "400",
      "lineHeight": "1.25rem"
    },
    "overline2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "400",
      "lineHeight": "1rem"
    },
    "overline3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.6875rem",
      "fontWeight": "400",
      "letterSpacing": "0.03125rem",
      "lineHeight": "1rem"
    },
    "subtitle3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "500",
      "letterSpacing": "0.00625rem",
      "lineHeight": "1.25rem"
    }
  },
  "display": {
    "lg": "1280px",
    "md": "960px",
    "sm": "600px",
    "xl": "1457px",
    "xxl": "1920px"
  },
  "family": {
    "body": "\"Roboto\", sans-serif",
    "heading": "\"Roboto\", sans-serif",
    "mono": "\"Roboto Mono\", sans-serif"
  },
  "heading": {
    "h1": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "3.5625rem",
      "fontWeight": "400",
      "lineHeight": "4rem"
    },
    "h2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "2.8125rem",
      "fontWeight": "400",
      "lineHeight": "3.25rem"
    },
    "h3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "2.25rem",
      "fontWeight": "400",
      "lineHeight": "2.75rem"
    },
    "h4": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "2rem",
      "fontWeight": "400",
      "lineHeight": "2.5rem"
    },
    "h5": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1.75rem",
      "fontWeight": "400",
      "lineHeight": "2.25rem"
    },
    "h6": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1.5rem",
      "fontWeight": "400",
      "lineHeight": "2rem"
    },
    "subtitle1": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1.375rem",
      "fontWeight": "400",
      "lineHeight": "1.75rem"
    },
    "subtitle2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1rem",
      "fontWeight": "500",
      "lineHeight": "1.5rem"
    }
  },
  "letterSpacing": {
    "large": "0.03125rem",
    "regular": "0.025rem",
    "small": "0.00625rem"
  },
  "lineHeight": {
    "body2": "1.25rem",
    "body3": "1rem",
    "h1": "4rem",
    "h2": "3.25rem",
    "h3": "2.75rem",
    "h4": "2.5rem",
    "h5": "2.25rem",
    "h6": "2rem",
    "subtitle1": "1.75rem",
    "subtitle2": "1.5rem"
  },
  "palette": {
    "error": {
      "0": "#000",
      "5": "#2d0001",
      "10": "#410002",
      "15": "#540003",
      "20": "#690005",
      "25": "#7e0007",
      "30": "#93000a",
      "35": "#a80710",
      "40": "#ba1a1a",
      "50": "#de3730",
      "60": "#ff5449",
      "70": "#ff897d",
      "80": "#ffb4ab",
      "90": "#ffdad6",
      "95": "#ffedea",
      "98": "#fff8f7",
      "99": "#fffbff",
      "100": "#fff"
    },
    "info": {
      "0": "#000",
      "10": "#001c38",
      "20": "#00315b",
      "30": "#004880",
      "40": "#0060a8",
      "50": "#0079d2",
      "60": "#2f94f3",
      "70": "#6aafff",
      "80": "#a1c9ff",
      "90": "#d3e4ff",
      "95": "#eaf1ff",
      "99": "#fdfcff",
      "100": "#fff"
    },
    "neutralVariant": {
      "0": "#000",
      "5": "#091312",
      "10": "#141d1c",
      "15": "#1e2827",
      "20": "#293231",
      "25": "#343d3c",
      "30": "#3f4947",
      "35": "#4a5453",
      "40": "#56605f",
      "50": "#6f7977",
      "60": "#899391",
      "70": "#a3adab",
      "80": "#bec9c7",
      "90": "#dae5e2",
      "95": "#e9f3f1",
      "98": "#f1fcf9",
      "99": "#f4fefc",
      "100": "#fff"
    },
    "neutral": {
      "0": "#000",
      "5": "#0e1212",
      "10": "#191c1d",
      "15": "#232626",
      "20": "#2e3132",
      "25": "#393c3d",
      "30": "#444748",
      "35": "#505354",
      "40": "#5c5f5f",
      "50": "#747878",
      "60": "#8e9192",
      "70": "#a9acac",
      "80": "#c4c7c7",
      "90": "#e1e3e3",
      "95": "#eff1f1",
      "98": "#f8fafa",
      "99": "#fafdfd",
      "100": "#fff"
    },
    "primary": {
      "0": "#000",
      "5": "#001413",
      "10": "#00201e",
      "15": "#002b29",
      "20": "#003734",
      "25": "#004340",
      "30": "#00504c",
      "35": "#005d58",
      "40": "#006a64",
      "50": "#00857f",
      "60": "#00a29a",
      "70": "#25beb5",
      "80": "#4fdbd1",
      "90": "#71f7ed",
      "95": "#b1fff7",
      "98": "#e4fffb",
      "99": "#f5f5f5",
      "100": "#fff"
    },
    "secondary": {
      "0": "#000",
      "5": "#001413",
      "10": "#051f1e",
      "15": "#102a28",
      "20": "#1c3532",
      "25": "#27403d",
      "30": "#324b49",
      "35": "#3e5754",
      "40": "#4a6360",
      "50": "#627c79",
      "60": "#7b9693",
      "70": "#96b1ad",
      "80": "#b0ccc8",
      "90": "#cce8e4",
      "95": "#daf7f3",
      "98": "#e4fffb",
      "99": "#f2fffc",
      "100": "#fff"
    },
    "success": {
      "0": "#000",
      "5": "#001413",
      "10": "#00201e",
      "15": "#002b29",
      "20": "#003734",
      "25": "#004340",
      "30": "#00504c",
      "35": "#005d58",
      "40": "#006a64",
      "50": "#00857f",
      "60": "#00a29a",
      "70": "#25beb5",
      "80": "#4fdbd1",
      "90": "#71f7ed",
      "95": "#b1fff7",
      "98": "#e4fffb",
      "99": "#f5f5f5",
      "100": "#fff"
    },
    "tertiary": {
      "0": "#000",
      "5": "#1b003b",
      "10": "#290055",
      "15": "#0c273f",
      "20": "#401b6e",
      "25": "#4b2879",
      "30": "#573486",
      "35": "#644092",
      "40": "#704da0",
      "50": "#8a66ba",
      "60": "#a57fd6",
      "70": "#c09af3",
      "80": "#d8b9ff",
      "90": "#eddcff",
      "95": "#f8edff",
      "98": "#fff7ff",
      "99": "#fffbff",
      "100": "#fff"
    },
    "warning": {
      "0": "#000",
      "10": "#221b00",
      "20": "#3a3000",
      "30": "#544600",
      "40": "#705d00",
      "50": "#8d7500",
      "60": "#aa8f0d",
      "70": "#c6a92e",
      "80": "#e4c548",
      "90": "#ffe16f",
      "95": "#fff0c3",
      "99": "#fffbff",
      "100": "#fff"
    }
  },
  "radius": {
    "full": "9999px",
    "l": "20px",
    "m": "16px",
    "none": "0px",
    "s": "12px",
    "xl": "24px",
    "xs": "8px",
    "xxl": "28px",
    "xxs": "4px",
    "xxxl": "36px"
  },
  "shade": {
    "black": "#000",
    "white": "#fff"
  },
  "size": {
    "body2": "0.875rem",
    "body3": "0.75rem",
    "caption3": "0.6875rem",
    "h1": "3.5625rem",
    "h2": "2.8125rem",
    "h3": "2.25rem",
    "h4": "2rem",
    "h5": "1.75rem",
    "h6": "1.5rem",
    "root": "16px",
    "subtitle1": "1.375rem",
    "subtitle2": "1rem"
  },
  "spacing": {
    "0": "0px",
    "1": "4px",
    "2": "8px",
    "3": "12px",
    "4": "16px",
    "5": "20px",
    "6": "24px",
    "7": "28px",
    "8": "32px",
    "9": "36px",
    "10": "40px",
    "11": "44px",
    "12": "48px",
    "13": "52px",
    "14": "56px",
    "15": "60px",
    "16": "64px"
  },
  "weight": {
    "bold": "600",
    "light": "300",
    "medium": "500",
    "regular": "400"
  }
};
export const dark = {
  "borderWidth": {
    "l": "3px",
    "m": "2px",
    "s": "1px"
  },
  "color": {
    "bg": {
      "background": "#0e1212",
      "errorContainer": "#93000a",
      "infoContainer": "#004880",
      "inverseSurface": "#e1e3e3",
      "inverseSurfaceVariant": "#eff1f1",
      "neutral": "#000",
      "primaryContainer": "#00504c",
      "secondaryContainer": "#324b49",
      "successContainer": "#00504c",
      "surface": "#191c1d",
      "surfaceOverlay": "#fff",
      "surfaceVariant": "#3f4947",
      "surface1": "#252728",
      "surface2": "#2b2e2f",
      "surface3": "#323536",
      "surface4": "#353738",
      "surface5": "#393c3d",
      "tertiaryContainer": "#573486",
      "warningContainer": "#544600"
    },
    "border": {
      "outline": "#899391",
      "outlineVariant": "#3f4947"
    },
    "brand": {
      "error": "#ffb4ab",
      "info": "#a1c9ff",
      "inversePrimary": "#006a64",
      "onError": "#690005",
      "onInfo": "#00315b",
      "onPrimary": "#003734",
      "onSecondary": "#1c3532",
      "onSuccess": "#003734",
      "onTertiary": "#401b6e",
      "onWarning": "#3a3000",
      "primary": "#4fdbd1",
      "secondary": "#b0ccc8",
      "success": "#4fdbd1",
      "tertiary": "#d8b9ff",
      "warning": "#e4c548"
    },
    "custom": {
      "bluePrimary": "#a5c8ff",
      "corePrimary": "#4fdbd1",
      "greenPrimary": "#50df9a",
      "highchartsColor1": "#f8bbd0",
      "highchartsColor2": "#81d4fa",
      "highchartsColor3": "#4caf50",
      "highchartsColor4": "#ba68c8",
      "highchartsColor5": "#9fa8da",
      "highchartsColor6": "#ef5350",
      "highchartsColor7": "#00acc1",
      "highchartsColor8": "#cddc39",
      "highchartsColor9": "#009688",
      "highchartsColor10": "#ff9800",
      "pinkPrimary": "#ffaedf",
      "purplePrimary": "#d7baff"
    },
    "fg": {
      "onBackground": "#e1e3e3",
      "onBlack": "#eff1f1",
      "onErrorContainer": "#ffdad6",
      "onInfoContainer": "#d3e4ff",
      "onInverseSurface": "#191c1d",
      "onInverseSurfaceVariant": "#2e3132",
      "onNeutral": "#fff",
      "onPrimaryContainer": "#71f7ed",
      "onSecondaryContainer": "#cce8e4",
      "onSuccessContainer": "#71f7ed",
      "onSurface": "#e1e3e3",
      "onSurfaceVariant": "#bec9c7",
      "onTertiaryContainer": "#eddcff",
      "onWarningContainer": "#ffe16f",
      "onWhite": "#191c1d"
    }
  },
  "content": {
    "body1": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1rem",
      "fontWeight": "400",
      "lineHeight": "1.5rem"
    },
    "body2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "400",
      "lineHeight": "1.25rem"
    },
    "body3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "400",
      "letterSpacing": "0.025rem",
      "lineHeight": "1rem"
    },
    "button": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "400",
      "lineHeight": "1.25rem"
    },
    "button2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "500",
      "lineHeight": "1rem"
    },
    "button3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.6875rem",
      "fontWeight": "500",
      "letterSpacing": "0.03125rem",
      "lineHeight": "1rem"
    },
    "caption": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "500",
      "lineHeight": "1.25rem"
    },
    "caption2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "500",
      "lineHeight": "1rem"
    },
    "caption3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.6875rem",
      "fontWeight": "500",
      "letterSpacing": "0.03125rem",
      "lineHeight": "1rem"
    },
    "overline": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "400",
      "lineHeight": "1.25rem"
    },
    "overline2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.75rem",
      "fontWeight": "400",
      "lineHeight": "1rem"
    },
    "overline3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.6875rem",
      "fontWeight": "400",
      "letterSpacing": "0.03125rem",
      "lineHeight": "1rem"
    },
    "subtitle3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "0.875rem",
      "fontWeight": "500",
      "letterSpacing": "0.00625rem",
      "lineHeight": "1.25rem"
    }
  },
  "display": {
    "lg": "1280px",
    "md": "960px",
    "sm": "600px",
    "xl": "1457px",
    "xxl": "1920px"
  },
  "family": {
    "body": "\"Roboto\", sans-serif",
    "heading": "\"Roboto\", sans-serif",
    "mono": "\"Roboto Mono\", sans-serif"
  },
  "heading": {
    "h1": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "3.5625rem",
      "fontWeight": "400",
      "lineHeight": "4rem"
    },
    "h2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "2.8125rem",
      "fontWeight": "400",
      "lineHeight": "3.25rem"
    },
    "h3": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "2.25rem",
      "fontWeight": "400",
      "lineHeight": "2.75rem"
    },
    "h4": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "2rem",
      "fontWeight": "400",
      "lineHeight": "2.5rem"
    },
    "h5": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1.75rem",
      "fontWeight": "400",
      "lineHeight": "2.25rem"
    },
    "h6": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1.5rem",
      "fontWeight": "400",
      "lineHeight": "2rem"
    },
    "subtitle1": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1.375rem",
      "fontWeight": "400",
      "lineHeight": "1.75rem"
    },
    "subtitle2": {
      "fontFamily": "\"Roboto\", sans-serif",
      "fontSize": "1rem",
      "fontWeight": "500",
      "lineHeight": "1.5rem"
    }
  },
  "letterSpacing": {
    "large": "0.03125rem",
    "regular": "0.025rem",
    "small": "0.00625rem"
  },
  "lineHeight": {
    "body2": "1.25rem",
    "body3": "1rem",
    "h1": "4rem",
    "h2": "3.25rem",
    "h3": "2.75rem",
    "h4": "2.5rem",
    "h5": "2.25rem",
    "h6": "2rem",
    "subtitle1": "1.75rem",
    "subtitle2": "1.5rem"
  },
  "palette": {
    "error": {
      "0": "#000",
      "5": "#2d0001",
      "10": "#410002",
      "15": "#540003",
      "20": "#690005",
      "25": "#7e0007",
      "30": "#93000a",
      "35": "#a80710",
      "40": "#ba1a1a",
      "50": "#de3730",
      "60": "#ff5449",
      "70": "#ff897d",
      "80": "#ffb4ab",
      "90": "#ffdad6",
      "95": "#ffedea",
      "98": "#fff8f7",
      "99": "#fffbff",
      "100": "#fff"
    },
    "info": {
      "0": "#000",
      "10": "#001c38",
      "20": "#00315b",
      "30": "#004880",
      "40": "#0060a8",
      "50": "#0079d2",
      "60": "#2f94f3",
      "70": "#6aafff",
      "80": "#a1c9ff",
      "90": "#d3e4ff",
      "95": "#eaf1ff",
      "99": "#fdfcff",
      "100": "#fff"
    },
    "neutralVariant": {
      "0": "#000",
      "5": "#091312",
      "10": "#141d1c",
      "15": "#1e2827",
      "20": "#293231",
      "25": "#343d3c",
      "30": "#3f4947",
      "35": "#4a5453",
      "40": "#56605f",
      "50": "#6f7977",
      "60": "#899391",
      "70": "#a3adab",
      "80": "#bec9c7",
      "90": "#dae5e2",
      "95": "#e9f3f1",
      "98": "#f1fcf9",
      "99": "#f4fefc",
      "100": "#fff"
    },
    "neutral": {
      "0": "#000",
      "5": "#0e1212",
      "10": "#191c1d",
      "15": "#232626",
      "20": "#2e3132",
      "25": "#393c3d",
      "30": "#444748",
      "35": "#505354",
      "40": "#5c5f5f",
      "50": "#747878",
      "60": "#8e9192",
      "70": "#a9acac",
      "80": "#c4c7c7",
      "90": "#e1e3e3",
      "95": "#eff1f1",
      "98": "#f8fafa",
      "99": "#fafdfd",
      "100": "#fff"
    },
    "primary": {
      "0": "#000",
      "5": "#001413",
      "10": "#00201e",
      "15": "#002b29",
      "20": "#003734",
      "25": "#004340",
      "30": "#00504c",
      "35": "#005d58",
      "40": "#006a64",
      "50": "#00857f",
      "60": "#00a29a",
      "70": "#25beb5",
      "80": "#4fdbd1",
      "90": "#71f7ed",
      "95": "#b1fff7",
      "98": "#e4fffb",
      "99": "#f5f5f5",
      "100": "#fff"
    },
    "secondary": {
      "0": "#000",
      "5": "#001413",
      "10": "#051f1e",
      "15": "#102a28",
      "20": "#1c3532",
      "25": "#27403d",
      "30": "#324b49",
      "35": "#3e5754",
      "40": "#4a6360",
      "50": "#627c79",
      "60": "#7b9693",
      "70": "#96b1ad",
      "80": "#b0ccc8",
      "90": "#cce8e4",
      "95": "#daf7f3",
      "98": "#e4fffb",
      "99": "#f2fffc",
      "100": "#fff"
    },
    "success": {
      "0": "#000",
      "5": "#001413",
      "10": "#00201e",
      "15": "#002b29",
      "20": "#003734",
      "25": "#004340",
      "30": "#00504c",
      "35": "#005d58",
      "40": "#006a64",
      "50": "#00857f",
      "60": "#00a29a",
      "70": "#25beb5",
      "80": "#4fdbd1",
      "90": "#71f7ed",
      "95": "#b1fff7",
      "98": "#e4fffb",
      "99": "#f5f5f5",
      "100": "#fff"
    },
    "tertiary": {
      "0": "#000",
      "5": "#1b003b",
      "10": "#290055",
      "15": "#0c273f",
      "20": "#401b6e",
      "25": "#4b2879",
      "30": "#573486",
      "35": "#644092",
      "40": "#704da0",
      "50": "#8a66ba",
      "60": "#a57fd6",
      "70": "#c09af3",
      "80": "#d8b9ff",
      "90": "#eddcff",
      "95": "#f8edff",
      "98": "#fff7ff",
      "99": "#fffbff",
      "100": "#fff"
    },
    "warning": {
      "0": "#000",
      "10": "#221b00",
      "20": "#3a3000",
      "30": "#544600",
      "40": "#705d00",
      "50": "#8d7500",
      "60": "#aa8f0d",
      "70": "#c6a92e",
      "80": "#e4c548",
      "90": "#ffe16f",
      "95": "#fff0c3",
      "99": "#fffbff",
      "100": "#fff"
    }
  },
  "radius": {
    "full": "9999px",
    "l": "20px",
    "m": "16px",
    "none": "0px",
    "s": "12px",
    "xl": "24px",
    "xs": "8px",
    "xxl": "28px",
    "xxs": "4px",
    "xxxl": "36px"
  },
  "shade": {
    "black": "#000",
    "white": "#fff"
  },
  "size": {
    "body2": "0.875rem",
    "body3": "0.75rem",
    "caption3": "0.6875rem",
    "h1": "3.5625rem",
    "h2": "2.8125rem",
    "h3": "2.25rem",
    "h4": "2rem",
    "h5": "1.75rem",
    "h6": "1.5rem",
    "root": "16px",
    "subtitle1": "1.375rem",
    "subtitle2": "1rem"
  },
  "spacing": {
    "0": "0px",
    "1": "4px",
    "2": "8px",
    "3": "12px",
    "4": "16px",
    "5": "20px",
    "6": "24px",
    "7": "28px",
    "8": "32px",
    "9": "36px",
    "10": "40px",
    "11": "44px",
    "12": "48px",
    "13": "52px",
    "14": "56px",
    "15": "60px",
    "16": "64px"
  },
  "weight": {
    "bold": "600",
    "light": "300",
    "medium": "500",
    "regular": "400"
  }
};
